import { useEffect, useState } from "react";
import { api, fileUrl } from "../../lib/api";
import { Panel, Btn, Field, inputCls, ImageUploader } from "./AdminUI";
import { Plus, Pencil, Trash2, Calendar } from "lucide-react";

const empty = { title: "", date: "", description: "", images: [], thumbnail: "" };

export default function ManageGallery() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api.get("/events").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (form.id) await api.put(`/events/${form.id}`, form);
    else await api.post("/events", form);
    setForm(null); load();
  };
  const del = async (id) => { if (window.confirm("Delete this event and its images?")) { await api.delete(`/events/${id}`); load(); } };

  return (
    <Panel title="Manage Gallery Folders" actions={<Btn onClick={() => setForm({ ...empty })} data-testid="add-event"><Plus size={15} /> Add Folder</Btn>}>
      <p className="text-sm text-[#5A6270] mb-4">Each folder is one occasion, classified by date. Add a short note describing what the folder contains, upload up to 10 photos, and choose which photo appears as the folder cover.</p>
      {form && (
        <form onSubmit={save} className="mb-6 p-4 rounded-lg bg-[#FAF7F0] border border-[#E5DECF] space-y-3" data-testid="event-form">
          <div className="grid sm:grid-cols-2 gap-3">
            <Field label="Folder / Occasion Title"><input className={inputCls} required placeholder="e.g. Visit of Hon'ble Justice to the Bar" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="event-title" /></Field>
            <Field label="Date"><input type="date" className={inputCls} required value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} data-testid="event-date" /></Field>
          </div>
          <Field label="Note — what this folder contains"><textarea rows={3} className={inputCls} placeholder="e.g. Photographs of the felicitation ceremony held on 5th August 2025." value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="event-desc" /></Field>
          <Field label="Photos (up to 10)"><ImageUploader paths={form.images} onChange={(imgs) => setForm({ ...form, images: imgs, thumbnail: imgs.includes(form.thumbnail) ? form.thumbnail : (imgs[0] || "") })} max={10} /></Field>
          {form.images.length > 0 && (
            <Field label="Cover thumbnail (shown on the folder)">
              <div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
                {form.images.map((p, i) => (
                  <button type="button" key={i} onClick={() => setForm({ ...form, thumbnail: p })} className={`relative aspect-square rounded-lg overflow-hidden border-2 ${form.thumbnail === p ? "border-[#D4AF37]" : "border-transparent"}`} data-testid={`set-thumb-${i}`}>
                    <img src={fileUrl(p)} alt="" className="w-full h-full object-cover" />
                    {form.thumbnail === p && <span className="absolute bottom-0 inset-x-0 text-[10px] bg-[#D4AF37] text-[#071B3D] text-center font-bold py-0.5">Cover</span>}
                  </button>
                ))}
              </div>
            </Field>
          )}
          <div className="flex gap-2"><Btn type="submit" data-testid="event-save">Save Folder</Btn><Btn type="button" variant="outline" onClick={() => setForm(null)}>Cancel</Btn></div>
        </form>
      )}
      <div className="space-y-3">
        {list.map((ev) => (
          <div key={ev.id} className="flex items-center justify-between gap-3 border border-[#F0E9DA] rounded-lg px-4 py-3" data-testid={`admin-event-${ev.id}`}>
            <div className="flex items-center gap-3">
              {(ev.thumbnail || ev.images[0]) && <img src={fileUrl(ev.thumbnail || ev.images[0])} alt="" className="w-14 h-14 rounded object-cover" />}
              <div>
                <div className="font-medium text-[#2a2422]">{ev.title}</div>
                <div className="text-xs text-[#5A6270] flex items-center gap-1"><Calendar size={12} /> {ev.date} · {ev.images.length} photo(s)</div>
              </div>
            </div>
            <div className="flex gap-2">
              <Btn variant="outline" onClick={() => setForm(ev)}><Pencil size={14} /></Btn>
              <Btn variant="danger" onClick={() => del(ev.id)} data-testid={`delete-event-${ev.id}`}><Trash2 size={14} /></Btn>
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
}
